import { CustomWindow } from "@ciaopeople/cp-shatsu/Ads/IAS";
import { basePrebidSlots, PrebidjsImpl } from "@ciaopeople/cp-shatsu/Ads";
import { isArray } from "@ciaopeople/cp-shatsu/TypeChecking";
import { VideoInfoRawData } from "../../../model/video/VideoInfo.js";
import { UserAdsData } from "../adcall/composable/UserAdsData.js";
import { AdCallParams } from "../AdCallParams.js";
import { AdUnit } from "../AdUnit.js";
import { AdParamsEnricher, PrebidModule } from "./PrebidModule.js";
import { CP_AdvSiteName } from "../adcall/CustomParams.js";
import { GDPRSdk } from "@ciaopeople/cp-shatsu/GDPR";

export class PrebidJS implements PrebidModule {


    private prebidImpl: PrebidjsImpl

    constructor(private site: CP_AdvSiteName,
        private window: Window,
        private userData: UserAdsData,
        private gdpr: Promise<GDPRSdk>) {

        this.prebidImpl = new PrebidjsImpl(window as CustomWindow, gdpr, userData)
    }

    load(): Promise<void> {
        return this.prebidImpl.loadSdk().then(_ => {
            return
        })
    }

    bidAndGetEnricher(adUnit: AdUnit, info: VideoInfoRawData): Promise<AdParamsEnricher> {

        const slots: basePrebidSlots = {
            sizes: [640, 480],
            id: "video",
            adunitId: `${this.site}_video`
        }

        return this.prebidImpl.doPrebid([slots])
            .then(data => {
                return (incoming) => {
                
                    const obj2: {[k:string] : string} = {};
                    Object.entries(data).forEach(x => {
                        const [slotId, slotValues] = x;

                        const serialized = Object.entries(slotValues).map(y => {
                            const [key, value] = y;
                            let uv = "";
                            if (isArray(value)) uv = value.join(",");
                            else uv = value
                            return key + "=" + uv;
                        }).join("&");

                        obj2[slotId] = serialized;
                    });

                    const targetingKey: string | undefined = Object.keys(obj2).find(e => e.includes("video"))
                    const targeting = encodeURIComponent( targetingKey ? obj2[targetingKey] : "");
                    const useParams: AdCallParams = incoming ? incoming : {};
                    useParams.pre_serialized_custom_params = useParams.pre_serialized_custom_params || [];
                    useParams.pre_serialized_custom_params.push(targeting);
                    return useParams;
                }
            }).catch(err => {
                return Promise.reject(err);
            });
      
    }


}